import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const wizardV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Wizard element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'wizard'>): void => {
    if (props?.style?.title?.text && !props?.content?.title?.iconColor) {
      const currentColor = props.style.title.text.color1;
      props.content = {
        ...props.content,
        title: {
          ...props.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
